export const LS_KEYS = {
  /** Last 5 explanation responses for instant re-access. Expiry: 24h */
  EXPLANATIONS_CACHE: "athr_explanations_cache",
  /** In-progress test answers. Expiry: until submitted or 48h */
  TEST_SESSION: "athr_test_session",
  /** Explanation language preference. Expiry: until changed */
  LANG_PREF: "athr_lang_pref",
  /** Token usage + window start. Syncs to Supabase every 5 min */
  USAGE_TOKENS: "athr_usage_tokens",
  /** Last viewed resource ID + page. Expiry: 7 days */
  LAST_RESOURCE: "athr_last_resource",
  /** Offline feedback queue. Expiry: until synced or 7 days */
  PENDING_FEEDBACK: "athr_pending_feedback",
} as const;

export type UsageTokensData = {
  tokens_used: number;
  window_start: string;
  last_synced_at: string;
};

export type ExplanationCacheEntry = {
  id: string;
  selection_text: string;
  explanation: string;
  resource_id: string;
  created_at: string;
};
